module.exports = __webpack_public_path__ + "static/media/IMG_5669.984fc8a3.jpg";